import { apiClient } from './client';

// Types for OngLaye API responses
export interface ValidateOngKeySuccessData {
  success: true;
  bizToken: string | null;
  faceIndex: string | null;
  orderDetails: {
    orderId: string;
    amount: number;
    vendorName: string;
  };
}

export interface ValidateOngKeyErrorData {
  success: false;
  error: {
    code: string;
    message: string;
  };
}

export type ValidateOngKeyResponse =
  | ValidateOngKeySuccessData
  | ValidateOngKeyErrorData;

// Backend wraps responses in this structure
interface ApiResponse<T> {
  success: boolean;
  status: number;
  data: T;
}

/**
 * Validate an ong_key from the OngLaye (Lucky Face) flow
 * This calls aye-user-backend to validate the ong_key
 * and retrieve the biz_token from the already-completed face verification
 *
 * @param ong_key - The ong_key from the URL query parameter
 * @returns The validation result with biz_token if valid
 */
export const validateOngKey = async (
  ong_key: string
): Promise<ValidateOngKeyResponse> => {
  try {
    const response = await apiClient.get<ApiResponse<ValidateOngKeyResponse>>(
      `/onglaye/validate`,
      { params: { ong_key: ong_key } }
    );
    // Backend wraps response in { success, status, data }, so unwrap it
    return response.data.data;
  } catch (error: any) {
    // Handle axios errors - backend wraps errors in { success, status, data }
    if (error.response?.data?.data) {
      return error.response.data.data as ValidateOngKeyResponse;
    }
    return {
      success: false,
      error: {
        code: 'NETWORK_ERROR',
        message: 'Failed to validate session. Please try again.',
      },
    };
  }
};
